import React from 'react';
import {
  Popper, ClickAwayListener, MenuItem, ListItemIcon, ListItemText, Paper, Tooltip, makeStyles,
} from '@material-ui/core';
import { MoreVert, Stop } from '@material-ui/icons';
import { IconButton } from '@michelin/acid-components';
import { ThemeType } from '@michelin/acid-components/build/types/ThemeType';
import { ProfileMenuItemProps } from '@michelin/central-provider/dist/components/ProfileBox/ProfileMenuItem';

interface OverflowMenuProps {
  menuItems: ProfileMenuItemProps[],
  title?: string,
  style?: React.CSSProperties,
  float?: 'right' | 'left'
}

const useValidationTooltipStyles = makeStyles((theme: ThemeType) => ({
  tooltip: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
  arrow: { color: theme.palette.primary.main },
}));

const OverflowMenu = (props:OverflowMenuProps) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const classes = useValidationTooltipStyles();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popper' : undefined;

  return (
    <div style={{
      display: 'block',
      position: 'relative',
      height: '30px',
      lineHeight: '30px',
      marginTop: -3,
      float: props.float,
      ...props.style,
    }}
    >
      <Tooltip
        placement="top"
        arrow
        title={props.title || ''}
        classes={{
          tooltip: classes.tooltip,
          arrow: classes.arrow,
        }}
      >
        <IconButton
          size="small"
          style={{
            height: 35, width: 35, padding: 8, marginTop: -5,
          }}
          onClick={handleClick}
          disabled={false}
          aria-describedby="id"
        >
          <MoreVert color="primary" style={{ height: 18 }} />
        </IconButton>
      </Tooltip>
      <Popper
        id={id}
        open={open}
        anchorEl={anchorEl}
        placement="bottom-end"
      >
        <ClickAwayListener mouseEvent="onMouseDown" onClickAway={() => setAnchorEl(null)}>
          <Paper elevation={2}>
            {props.menuItems.map((menuItem) => (
              <MenuItem onClick={menuItem.action} key={`${menuItem.label}`}>
                <ListItemIcon style={{ minWidth: '33px' }}>
                  {menuItem.icon ? (
                    <menuItem.icon color="primary" />
                  ) : (
                    <Stop color="primary" style={{ display: 'none' }} />
                  )}
                </ListItemIcon>
                <ListItemText primary={menuItem.label} />
              </MenuItem>
            ))}
          </Paper>
        </ClickAwayListener>
      </Popper>
    </div>
  );
};

export {
  OverflowMenu,
};
